showHideModalCenter('.show-modal', '.modal-midia');

function showHideModalCenter(btnShowMode, modal) {
    const select = (element) => document.querySelector(element);
    const selectAll = (element) => document.querySelectorAll(element);

    selectAll(btnShowMode)?.forEach(btn => {
        var dataModal = btn.getAttribute('data-modal');

        btn.addEventListener('click', ()=> select(`${modal}#${dataModal}`)?.classList.toggle('show'))
        selectAll(`${modal}#${dataModal} .close-modal`)?.forEach(btnCloseModalCurrent => btnCloseModalCurrent.addEventListener('click', ()=> select(`${modal}#${dataModal}`)?.classList.remove('show')));
    })
}

